import { MutationList } from './mutation-list';
import {MutationTree} from "vuex";
import {mainRootState, appointment, user} from "@/store/types";

export type Mutations<S = mainRootState> = {
    [MutationList.SAVE_APPOINTMENT](state: S, payload: appointment): void;
    [MutationList.TOGGLE_SIDEBAR](state: S): void;
    [MutationList.SPLICE_APPOINTMENT_FROM_APPOINTMENT_ARRAY](state: S, payload: number): void;
    [MutationList.SET_TRANSITION](state: S, payload: string): void;
    [MutationList.ADD_HISTORY_COUNT](state: S): void;
    [MutationList.REMOVE_HISTORY_COUNT](state: S): void;
    [MutationList.SET_BACKWARDS_TRUE](state: S): void;
    [MutationList.SET_BACKWARDS_FALSE](state: S): void;
}

export const mutations: MutationTree<mainRootState> & Mutations = {
    [MutationList.SAVE_APPOINTMENT] (state, payload) {
        state.appointments.push(payload);
    },
    [MutationList.TOGGLE_SIDEBAR](state) {
        state.sidebarVisible = !state.sidebarVisible
    },


    [MutationList.SPLICE_APPOINTMENT_FROM_APPOINTMENT_ARRAY](state, payload) {
        state.appointments.splice(payload, 1)
    },
    [MutationList.SET_TRANSITION](state, payload) {
        state.transition = payload
    },
    [MutationList.ADD_HISTORY_COUNT](state) {
        state.historyCounter++
    },
    [MutationList.REMOVE_HISTORY_COUNT](state) {
        state.historyCounter--
    },
    [MutationList.SET_BACKWARDS_TRUE](state) {
        state.backwards = true;
    },
    [MutationList.SET_BACKWARDS_FALSE](state) {
        state.backwards = false;
    }
};